

export const SET_HUE = 'SET_HUE';

export const FETCH_POST = 'FETCH_POST';
export const FETCH_POSTS = 'FETCH_POSTS';

export const PUSH_TOAST = 'PUSH_TOAST';
export const POP_TOAST = 'POP_TOAST';



// WEBPACK FOOTER //
// ./src/ducks/actionTypes.js